/* eslint-disable no-undef */
import moment from 'moment';

const setContextSentry = ({ name = 'default', payload = {}}) => {
    Raven.context(name, payload);
}

const setBreadcrumbSentry = ({ type = 'default', category = 'info', message = '', level = 'info', data = {}}) => {
    const payload = {
        type,
        category,
        level,
        message,
        data,
        timestamp: moment().unix(),
    };
    
     if(Raven) Raven.captureBreadcrumb(payload);
}

const captureExceptionSentry = (err) => {
    if(Raven) Raven.captureException(err);  
}

const setSentryUser = (user) => {
    if(Raven) Raven.setUserContext(user);
}

export {
    setContextSentry,
    setBreadcrumbSentry,
    captureExceptionSentry,
    setSentryUser
}